import axios from 'axios';
import urlConfig from './urlGet';

export default axios.create({
  baseURL: urlConfig.urlFile,
  headers: {
    'Content-Type': 'application/json',
  }
});
